<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="container-privacy">
            <div class="header-privacy">
                <h1><p>
                    Aviso de<br>Privacidade
                </p></h1>
            </div>
            <div class="privacy-content">
                <p class="date">
                </p>
                <p>
                    O objetivo da FAD é fornecer uma plataforma para assinar documentos em qualquer parte do mundo de
                    forma digital e eficiente, conforme descrito em nossos Termos de Uso, disponível em: <a
                        [routerLink]="['/termos-e-condicoes']">Termos e Condições</a>
                </p>
                <p>
                    Esta Política de Privacidade, da plataforma FAD, rege a aquisição, acesso e utilização da plataforma
                    de Assinatura Autógrafa Digital (“FAD”) e outros serviços e produtos relacionados, comercializados
                    pela BIOMETRIC AGREEMENT DO BRASIL LTDA (“BIOMETRIC” ou “nós”) através de nosso aplicativo,
                    Plataforma Digital ou website.
                </p>
                <p>
                    Portanto, é muito importante que você entenda que o presente documento vincula todas aquelas pessoas
                    ou entidades (“você”, "usuário" ou “cliente”) que adquirem a plataforma de Assinatura Autógrafa
                    Digital (“FAD”) e serviços ou produtos adicionais relacionados (“Produtos”), e, além disso, pode
                    vincular também todos os nossos colaboradores.
                </p>
                <p>
                    Ao acessar nossa plataforma e/ou adquirir qualquer um dos nossos Produtos ou Serviços, você declara
                    ser maior de idade (18 anos de idade ou mais, ou a maioridade na jurisdição em que você reside), em
                    pleno exercício e usufruto dos seus direitos, aceitando integralmente os presentes Termos. Se você
                    está concordando com estes Termos em nome de uma organização ou entidade, você declara e garante que
                    está autorizado a concordar com estes Termos em nome da organização ou entidade e a vinculá-las a
                    estes Termos (nesse caso, as referências a "você" e nestes Termos, exceto por esta frase, referem-se
                    à organização ou entidade). Se você não concordar com estes Termos, deverá abster-se de utilizar o
                    FAD e/ou adquirir os Produtos e Serviços que lhe são oferecidos.
                </p>
                <ol>
                    <li><span>DEFINIÇÕES IMPORTANTES DA LGPD</span> <br><br>
                        <p>A Lei Geral de Proteção de Dados - LGPD (Lei nº 13.709/2018) entrou em vigor em setembro de
                            2.020 e tem como objetivo proteger os dados pessoais de uma pessoa natural que esteja no
                            Brasil, também conhecida como titular de dados.</p>
                        <p>Em resumo, a LGPD se aplicará quando:</p>
                        <ol type="a">
                            <li>a operação do tratamento dos dados for realizada no Brasil;</li>
                            <li>a atividade do tratamento dos dados tenha por objetivo a oferta ou o fornecimento de
                                serviços às pessoas localizadas no Brasil;
                            </li>
                            <li>os dados pessoais tenham sido coletados no Brasil.</li>
                        </ol>
                        <br>
                        <p>
                            Existem duas categorias de dados previstas na lei: “dado pessoal” e “dado pessoal sensível”.
                            O “dado pessoal” é qualquer dado que identifique ou torne identificável uma pessoa física,
                            ao passo que “dado pessoal sensível” é aquele que, por sua natureza, diz respeito às
                            informações que merecem um cuidado maior, principalmente para proteção contra
                            discriminações, tais como dados sobre origem racial ou étnica, convicção religiosa, opinião
                            política, entre outros, a depender da legislação aplicável.
                        </p>
                        <p>
                            Os responsáveis pelo tratamento de dados pessoais são os agentes de tratamento, denominados
                            como: “controlador”, “operador” e ainda podemos ter a figura do “suboperador”.
                        </p>
                        <p>
                            O “controlador” é a pessoa física ou jurídica a quem compete decidir sobre o tratamento de
                            dados pessoais em seu poder. Por outro lado, o “operador” é pessoa física ou jurídica que
                            realiza o tratamento de dados pessoais em nome e de acordo com as orientações do controlador
                            e, o “suboperador”, nessa mesma linha, é qualquer pessoa que auxilia o operador a realizar o
                            tratamento de dados pessoais em nome do controlador.
                        </p>
                    </li>
                    <br>

                    <li><span>TIPOS DE DADOS PESSOAIS COLETADOS</span> <br><br>
                        <p>Na decorrência da prestação de seus serviços, a BIOMETRIC poderá coletar os seguintes dados
                            pessoais:</p>
                        <ol type="a">
                            <li>Nome completo e dados de contato, como telefone e e-mail;</li>
                            <li>Fotografia;</li>
                            <li>Imagem da assinatura autógrafa/manuscrita;</li>
                            <li>Biometria da assinatura;</li>
                            <li>Vídeo do momento da assinatura;</li>
                            <li>Voz;</li>
                            <li>Foto ou vídeo de sua identificação (se solicitado pelo cliente);</li>
                            <li>Credenciais de conta, como senhas e outras informações de segurança para autenticação e
                                acesso;
                            </li>
                            <li>Informações para pagamento como número, validade e nome completo como está escrito no
                                cartão. Ainda podem ser solicitados dados para o preenchimento visando a nota fiscal da
                                compra como CPF/CNPJ.
                            </li>
                            <br>
                        </ol>
                    </li>

                    <li><span>ORIGEM DA COLETA DOS DADOS PESSOAIS</span> <br><br>
                        <p>
                            A BIOMETRIC, se for o caso, obterá dados pessoais do Usuário:
                        </p>
                        <ol type="a">
                            <li><strong>Por meio da interação com a BIOMETRIC e seus serviços:</strong> Quando o Usuário
                                usar a plataforma do FAD, utilizar nossos serviços, solicitar informações ou enviar
                                e-mail para o suporte.
                            </li>
                            <li><strong>Por meio de cookies:</strong> a BIOMETRIC poderá utilizar, em sua plataforma,
                                cookies para coletar informações do Usuário e melhorar sua experiência de navegação.
                            </li>
                        </ol>
                    </li>
                    <br>

                    <li><span>FINALIDADES PARA A COLETA  DOS DADOS PESSOAIS</span><br><br>
                        <p>Quando coletados, a BIOMETRIC utilizará os dados pessoais para as seguintes finalidades:</p>
                        <ol type="a">
                            <li>Realizar as atividades necessárias para fornecer ao Usuário serviços de multimídia de
                                assinatura autógrafa digital;
                            </li>
                            <li>Fornecer e melhorar os serviços, bem como para fins de compliance;</li>
                            <li>Cumprir com uma obrigação legal;</li>
                            <li>Quando for o caso, responder solicitações da Autoridade Nacional de Proteção de Dados
                                (ANPD) ou demais autoridades públicas e governamentais;
                            </li>
                            <li>Atender chamados e/ou pedidos de contatos, sempre que solicitado;</li>
                            <li>Processar pagamentos, mesmo que através de terceiros, ocasião na qual serão
                                compartilhados os dados estritamente necessários para a execução do contrato;
                            </li>
                            <li>Configurar e administrar a conta do Usuário;</li>
                            <li>Fornecer assistência técnica ao Usuário;</li>
                            <li>Fornecer ao Usuário marketing, publicidade, propaganda, incluindo promoções de nossos
                                serviços;
                            </li>
                            <li>Detectar, prevenir ou investigar possíveis incidentes de segurança ou fraudes.</li>
                        </ol>
                        <br>
                        <p>
                            Importante ressaltar que os dados sensíveis que forem coletados pela BIOMETRIC serão
                            eliminados imediatamente após a assinatura dos documentos.
                        </p>
                        <p>
                            Dessa forma, resta claro que, sempre nos limites impostos pela Lei, todo e qualquer
                            procedimento adotado que importe em coleta de dados pessoais terão apenas tratamentos
                            específicos vinculados essencialmente nas finalidades ora expostas.
                        </p>
                        <p>
                            Além disso, saiba que se tivermos a intenção de tratar os seus dados pessoais para qualquer
                            outra finalidade que não essas descritas acima, você receberá todas as informações
                            adicionais relevantes em relação ao eventual tratamento idealizado.
                        </p>
                        <p>
                            Ressaltamos que ao utilizar a nossa plataforma, o Usuário poderá acessar outras páginas na
                            Internet, as quais poderão coletar dados e informações gerais para finalidades distintas
                            daquelas aqui descritas. Dessa forma, é importante esclarecer que nós não nos
                            responsabilizamos pelo tratamento de dados realizado em tais páginas.
                        </p>
                        <p>
                            Por fim, esclarecemos que quando você não quiser que seus dados pessoais sejam utilizados
                            para envio de informações relacionadas a marketing, publicidade, propaganda e promoções,
                            você deverá nos informar através do e-mail: <a
                                href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                        </p>
                        <br>
                    </li>

                    <li><span>COMPARTILHAMENTO DOS DADOS PESSOAIS</span><br><br>
                        <p>A BIOMETRIC poderá compartilhar os seus dados em algumas situações com os seguintes parceiros
                            e/ou terceiros, conforme demonstramos a seguir:
                        </p>
                        <ol type="a">
                            <li>Empresas parceiras, tais como provedores de serviços terceirizados e outras empresas que
                                nos auxiliam no oferecimento de nossos serviços ou que possam tomar providências em
                                nosso nome, protegendo nossos direitos, usuários, sistemas e serviços;
                            </li>
                            <li>Terceiros para o qual a BIOMETRIC deva uma satisfação ou tenha autorização para
                                divulgação de informações por lei (Exemplo: órgãos governamentais, agências reguladoras,
                                poder judiciário e outras autoridades públicas);
                            </li>
                            <li>Terceiros a fim de participar da venda, fusão, aquisição, reestruturação, joint venture,
                                cessão, transferência de parte ou todo negócio da BIOMETRIC, hipótese na qual os dados
                                do Usuário serão considerados um ativo e transferidos em uma eventual negociação;
                            </li>
                            <li>Terceiros que necessitem dos dados para proteger os direitos da BIOMETRIC;</li>
                            <li>Qualquer pessoa física ou jurídica para o qual o Usuário solicite a portabilidade de
                                seus dados.
                            </li>
                            <br>
                        </ol>
                    </li>

                    <li><span>TRANSFERÊNCIA INTERNACIONAL DE DADOS PESSOAIS</span><br><br>
                        <p>
                            Conforme determina a atual legislação vigente, a transferência internacional de dados
                            pessoais será permitida, independentemente de consentimento do Usuário, nos seguintes casos:
                        </p>
                        <ol type="a">
                            <li>quando a transferência for necessária para a cooperação jurídica internacional entre
                                órgãos públicos de inteligência, de investigação e de persecução, de acordo com os
                                instrumentos de direito internacional;
                            </li>
                            <li>quando a transferência for necessária para a proteção da vida ou da incolumidade física
                                do titular ou de terceiro;
                            </li>
                            <li>quando a autoridade nacional autorizar a transferência;</li>
                            <li>quando a transferência resultar em compromisso assumido em acordo de cooperação
                                internacional;
                            </li>
                            <li>quando a transferência for necessária para a execução de política pública ou atribuição
                                legal do serviço público;
                            </li>
                            <li>quando o titular tiver fornecido o seu consentimento específico e em destaque para a
                                transferência, com informação prévia sobre o caráter internacional da operação,
                                distinguindo claramente essa de outras finalidades; ou
                            </li>
                            <li>nas demais hipóteses previstas na Lei Geral de Proteção de Dados brasileira.</li>
                            <br>
                        </ol>
                        <p>
                            A BIOMETRIC destaca o comprometimento em contratar apenas fornecedores que adotem
                            medidas de segurança e boas práticas compatíveis com o nível de proteção estabelecido
                            pela legislação brasileira, conforme regulamentado pela Autoridade Nacional de Proteção
                            de Dados (ANPD). Na ausência de regulamentação, asseguramos ao Usuário que utilizaremos
                            empresas que estejam em conformidade com as demais normas de proteção de dados no mundo.
                        </p>
                    </li>

                    <li><span>PRAZO DE TRATAMENTO DOS DADOS PESSOAIS</span><br><br>
                        <p>
                            A BIOMETRIC calcula o período de retenção dos dados pessoais de acordo com os seguintes
                            critérios:
                        </p>
                        <ol type="a">
                            <li>Período necessário para cumprir o propósito da coleta;</li>
                            <li>Quando o Usuário ou terceiro que concedeu acesso aos serviços da BIOMETRIC deixar de
                                utilizar estes serviços ou solicitar a revogação do consentimento;
                            </li>
                            <li>O tempo necessário para demonstrar o cumprimento dos deveres e obrigações da
                                BIOMETRIC;
                            </li>
                            <li>O período necessário previsto em Lei, regulamentações, decisões judiciais, etc;</li>
                            <li>Determinação da Autoridade Nacional de Proteção de Dados;</li>
                            <li>Cumprimento de obrigação legal ou regulatória pelo controlador;</li>
                            <li>Perfeita execução do contrato;</li>
                            <li>Necessidades atinentes a observância do ordenamento jurídico, bem como para eventuais
                                disputas judiciais;
                            </li>
                            <li>Estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados
                                pessoais;
                            </li>
                            <li>Transferência a terceiro, desde que respeitados os requisitos de tratamento de dados
                                dispostos em lei; ou
                            </li>
                            <li>Uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados
                                os dados.
                            </li>
                            <br>
                        </ol>
                    </li>

                    <li><span>DIREITOS DO TITULAR</span><br><br>
                        <p>Conforme Lei Geral de Proteção de Dados Brasileira, o Usuário terá os seguintes direitos
                            quanto ao tratamento de seus dados pessoais:</p>
                        <ol type="a">
                            <li><strong>Direito de Confirmação:</strong> o Usuário poderá confirmar se a BIOMETRIC
                                realiza o tratamento de algum dado pessoal seu;
                            </li>
                            <li><strong>Direito de Acesso:</strong> o Usuário poderá fazer uma solicitação por escrito
                                para obter detalhes de como suas informações estão sendo utilizadas, bem como de ter uma
                                cópia das referidas informações;
                            </li>
                            <li><strong>Direito a Correção:</strong> o Usuário poderá corrigir ou remover eventuais
                                dados seus que estejam incompletos, inexatos ou desatualizados;
                            </li>
                            <li><strong>Direito de Anonimização, bloqueio ou eliminação:</strong> o Usuário poderá
                                solicitar a anonimização, bloqueio ou eliminação de dados desnecessário, excessivos ou
                                tratados em desconformidade com as finalidades a qual deu consentimento, observando-se,
                                para tanto, demais normas do ordenamento jurídico;
                            </li>
                            <li><strong>Direito de Exclusão:</strong> o Usuário poderá solicitar a exclusão de alguns
                                dados, exceto aqueles em que a lei autorize a sua conservação;
                            </li>
                            <li><strong>Direito de Informação:</strong> O Usuário poderá solicitar informações das
                                entidades públicas e privadas com as quais a BIOMETRIC realizou o uso compartilhado de
                                seus dados, bem como das consequências caso opte por não consentir na coleta e
                                tratamento de seus dados pessoais;
                            </li>
                            <li><strong>Direito de Recusar Marketing:</strong> O Usuário, poderá, a qualquer momento,
                                solicitar o cancelamento de recebimento de propagandas e outros materiais pelo próprio
                                link disponibilizado no e-mail marketing enviado;
                            </li>
                            <li><strong>Direito de Portabilidade:</strong> O Usuário poderá solicitar que seus dados
                                pessoais sejam transferidos a si próprios ou terceiros, salvo aqueles que já tenham sido
                                anonimizados e excluídos pela BIOMETRIC;
                            </li>
                            <li><strong>Direito de Revogação do Consentimento:</strong> O Usuário poderá cancelar
                                qualquer consentimento concedido de maneira prévia à BIOMETRIC para utilizar seus dados
                                pessoais. O Usuário tem ciência que o cancelamento não afetará a utilização ou
                                compartilhamento dos dados realizados anteriormente ao pedido de revogação do
                                consentimento.
                            </li>
                            <br>
                        </ol>
                        <p>
                            Os direitos previstos neste capítulo não são absolutos, devendo o Usuário, sempre que quiser
                            exercê-los, contatar a BIOMETRIC através do canal: <a
                                href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                        </p>
                        <p>
                            Para que o atendimento seja realizado visando maior segurança para o Usuário e prevenindo
                            possíveis fraudes, é necessário que o titular, ao encaminhar a sua solicitação, envie para o
                            nosso e-mail:
                        </p>
                        <ol type="a">
                            <li>Nome completo;</li>
                            <li>Cópias simples ou cópia digital do documento de identificação oficial, para comprovação
                                de identidade, como, por exemplo: RG, CNH, passaporte;
                            </li>
                            <li>No caso de solicitação em nome de um menor de 18 (dezoito) anos, deverá ser apresentada
                                uma certidão de nascimento ou documento oficial que comprove a personalidade do pai/mãe
                                ou responsável.
                            </li>
                        </ol>
                        <br>
                        <p>
                            A BIOMETRIC ainda esclarece que:
                        </p>
                        <ol type="a">
                            <li>Quando for o caso de solicitação para exercer direito de titular d dados pessoais, em
                                nome de terceiro maior de 18 (dezoito) anos, o solicitante, deverá anexar uma procuração
                                comprovando seus poderes para agir;
                            </li>
                            <li>Em caso de retificação, anexe cópia da justificativa que comprove o erro nos dados que
                                deseja retificar;
                            </li>
                            <li>A confirmação de existência ou o acesso a dados pessoais serão providenciados, mediante
                                requisição do titular: em formato simplificado, imediatamente; ou por declaração clara e
                                completa, fornecida no prazo de até 15 (quinze) dias, e que indique origem dos dados,
                                critérios utilizados, finalidade do tratamento (observados os segredos comercial e
                                industrial);
                            </li>
                            <li>Caso o pedido feito pelo titular dos dados seja negado pela BIOMETRIC, o titular tem
                                direito de saber os motivos da rejeição e, ainda, de fazer uma reclamação à ANPD
                                (Autoridade Nacional de Proteção de Dados).
                            </li>
                            <br>
                        </ol>
                    </li>

                    <li><span>MEDIDAS DE SEGURANÇA ADOTADAS</span><br><br>
                        <p>A BIOMETRIC utiliza tecnologias e procedimentos adequados para proteger eventuais dados
                            pessoais coletados (incluindo proteção administrativas, técnicas e físicas) de acordo com o
                            nível de risco e o serviço fornecido, possuindo uma equipe legalmente responsável para lidar
                            com o gerenciamento seguro dos dados em consonância com as previsões legais, requisitos
                            regulatórios, mudanças de tecnologia, dentre outros fatores relevantes que possam
                            influenciar na forma de proteger os dados pessoais.</p>
                        <p>Nós empregamos todos os esforços razoáveis de mercado para garantir a segurança de seus
                            sistemas e dos dados coletados, utilizando provedores de Internet e servidores de bancos de
                            dados e armazenamento altamente qualificados e conceituados, além de certificados de
                            segurança (ISO 27001), criptografia nos centros de dados, e software de proteção contra
                            acesso não autorizado aos sistemas, bem como métodos padrões para criptografar e anonimizar
                            os dados coletados.</p>
                        <p>
                            A BIOMETRIC protege as informações geradas por apenas 30 (trinta) dias, após os quais são
                            automaticamente excluídas. A infraestrutura e os canais de comunicação estão sob protocolos
                            seguros e técnicas de criptografia.
                        </p>
                        <p>
                            No entanto, em razão da própria natureza da Internet, não é possível garantir que terceiros
                            mal-intencionados não logrem sucesso em acessar indevidamente as informações armazenadas,
                            razão pela qual, caso isso ocorra, a BIOMETRIC se responsabilizará nos limites previstos em
                            Lei.
                        </p>
                    </li>

                    <li><span>COOKIES</span><br><br>
                        <p>
                            A BIOMETRIC e seus fornecedores terceirizados poderão utilizar cookies para armazenar e
                            gerenciar as preferências do Usuário, oferecer publicidade direcionada, habilitar conteúdos
                            e coletar dados analíticos e de utilização, por exemplo. O uso de cookies e outras
                            tecnologias de rastreamento é um padrão em sites e plataforma, através do qual são coletadas
                            informações sobre as atividades do Usuário na plataforma, sites ou outros serviços.
                        </p>
                        <p>
                            Um cookie é um pequeno arquivo de texto, colocado em um computador ou outro dispositivo,
                            utilizado para identificar o Usuário, dispositivo utilizado e para coletar informações e
                            podem desempenhar as seguintes funções:
                        </p>
                        <ol type="a">
                            <li>Cookies Necessários: são essenciais para permitir que o Usuário navegue em uma
                                plataforma e utilize seus recursos.
                            </li>
                            <li>Cookies de Desempenho: eles coletam informações de como o Usuário utiliza a plataforma
                                da BIOMETRIC e servem para melhorar sua navegação e aprimorar sua experiência. As
                                informações coletadas incluem, por exemplo, navegadores de internet e sistemas
                                operacionais utilizados, o nome de domínio do site visitado anteriormente, o número de
                                visitas, a duração média da visita e as páginas visualizadas.
                            </li>
                            <li>Cookies Funcionais: eles permitem que a plataforma relembre escolhas que o Usuário fez
                                (tais como o seu nome de usuário ou ID, preferência de idioma ou a área ou região onde o
                                Usuário está) e forneça recursos aprimorados e mais pessoais.
                            </li>
                            <li>Cookies de Publicidade: eles rastreiam os hábitos de navegação do Usuário e são usados
                                para fornecer publicidade direcionada. Estes cookies também limitam o número de vezes
                                que você vê um anúncio e medem a eficácia das campanhas publicitárias. Eles lembram,
                                também, que o Usuário já visitou um site e esta informação é compartilhada com outras
                                organizações, como anunciantes.
                            </li>
                            <br>
                        </ol>
                        <p>
                            A BIOMETRIC utiliza os seguintes cookies:
                        </p>
                        <ol type="a">
                            <li>Entrada de Usuário;</li>
                            <li>Identificação;</li>
                            <li>Segurança do Usuário;</li>
                            <li>Sessão de balanceamento de carga;</li>
                            <li>Plug-in;</li>
                            <li>Propriedade;</li>
                            <li>Sessão;</li>
                            <li>Análise;</li>
                            <li>Publicidade.</li>
                            <br>
                        </ol>
                        <p>
                            A qualquer momento o Usuário poderá desabilitar os Cookies através das configurações de seu
                            navegador, instalando plug-ins disponíveis no mercado, ou ainda fazendo uso de outras
                            tecnologias que entenda serem necessárias.
                        </p>
                    </li>

                    <li><span>ENCARREGADO DE DADOS / DPO (“Data Protection Officer”)</span><br><br>
                        <p>A BIOMETRIC possui um encarregado de dados, também chamado de Data Protection Officer
                            (DPO).</p>
                        <p>
                            Dessa forma, conforme a LGPD determina, caso você tenha alguma questão específica sobre
                            proteção de dados que ainda não tenha sido esclarecida por nossa Política de Privacidade,
                            Termos de Uso do Website ou pelo Contrato específico que você tenha assinado conosco,
                            recomendamos que entre em contato com o DPO da BIOMETRIC através do seguinte e-mail:
                            <a href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                        </p>
                    </li>

                    <li><span>ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE</span><br><br>
                        <p>A BIOMETRIC busca constantes atualizações e aprimoramentos, assim a presente Política de
                            Privacidade poderá ser atualizada a qualquer tempo sempre visando uma melhor prestação e
                            proteção aos usuários.</p>
                        <p>
                            Por isso, é importante que o Usuário consulte o documento regularmente em
                            <a [routerLink]="['/termos-e-condicoes']">Assinatura</a>, para verificar se continua
                            concordando com
                            seus termos antes de seguir com a navegação ou com o preenchimento de algum recurso do
                            website.
                        </p>
                        <p>
                            Caso solicitado pelo Usuário, a presente Política de Privacidade poderá ser enviada por
                            e-mail.
                        </p>
                    </li>

                    <li><span>LEGISLAÇÃO E FORO</span><br><br>
                        <p>Essa Política será regida, interpretada e executada de acordo com as leis da República
                            Federativa do Brasil, independentemente dos conflitos dessas leis com leis de outros estados
                            ou países, sendo competente o Foro de São Paulo, para dirimir qualquer dúvida decorrente
                            deste instrumento. O Usuário consente, expressamente, com a competência desse juízo, e
                            renuncia, neste ato, à competência de qualquer outro foro, por mais privilegiado que seja ou
                            venha a ser.</p>
                    </li>
                </ol>
                <br>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>Aviso de Privacidade</h1>
                <p class="text">
                </p>
                <p class="text">
                    O objetivo da FAD é fornecer uma plataforma para assinar documentos em qualquer parte do mundo de
                    forma digital e eficiente, conforme descrito em nossos Termos de Uso, disponível em: <a
                        [routerLink]="['/termos-e-condicoes']">Termos e Condições</a>
                </p>
                <p class="text">
                    Esta Política de Privacidade, da plataforma FAD, rege a aquisição, acesso e utilização da plataforma
                    de Assinatura Autógrafa Digital (“FAD”) e outros serviços e produtos relacionados, comercializados
                    pela BIOMETRIC AGREEMENT DO BRASIL LTDA (“BIOMETRIC” ou “nós”) através de nosso aplicativo,
                    Plataforma Digital ou website.
                </p>
                <p class="text">
                    Portanto, é muito importante que você entenda que o presente documento vincula todas aquelas pessoas
                    ou entidades (“você”, "usuário" ou “cliente”) que adquirem a plataforma de Assinatura Autógrafa
                    Digital (“FAD”) e serviços ou produtos adicionais relacionados (“Produtos”), e, além disso, pode
                    vincular também todos os nossos colaboradores.
                </p>
                <p class="text">
                    Ao acessar nossa plataforma e/ou adquirir qualquer um dos nossos Produtos ou Serviços, você declara
                    ser maior de idade (18 anos de idade ou mais, ou a maioridade na jurisdição em que você reside), em
                    pleno exercício e usufruto dos seus direitos, aceitando integralmente os presentes Termos. Se você
                    está concordando com estes Termos em nome de uma organização ou entidade, você declara e garante que
                    está autorizado a concordar com estes Termos em nome da organização ou entidade e a vinculá-las a
                    estes Termos (nesse caso, as referências a "você" e nestes Termos, exceto por esta frase, referem-se
                    à organização ou entidade). Se você não concordar com estes Termos, deverá abster-se de utilizar o
                    FAD e/ou adquirir os Produtos e Serviços que lhe são oferecidos.
                </p>
                <ol class="text">

                    <li><span>DEFINIÇÕES IMPORTANTES DA LGPD</span> <br><br>
                        <p>A Lei Geral de Proteção de Dados - LGPD (Lei nº 13.709/2018) entrou em vigor em setembro de
                            2.020 e tem como objetivo proteger os dados pessoais de uma pessoa natural que esteja no
                            Brasil, também conhecida como titular de dados.</p>
                        <p>Em resumo, a LGPD se aplicará quando:</p>
                        <ol type="a">
                            <li>a operação do tratamento dos dados for realizada no Brasil;</li>
                            <li>a atividade do tratamento dos dados tenha por objetivo a oferta ou o fornecimento de
                                serviços às pessoas localizadas no Brasil;
                            </li>
                            <li>os dados pessoais tenham sido coletados no Brasil.</li>
                        </ol>
                        <br>
                        <p>
                            Existem duas categorias de dados previstas na lei: “dado pessoal” e “dado pessoal sensível”.
                            O “dado pessoal” é qualquer dado que identifique ou torne identificável uma pessoa física,
                            ao passo que “dado pessoal sensível” é aquele que, por sua natureza, diz respeito às
                            informações que merecem um cuidado maior, principalmente para proteção contra
                            discriminações, tais como dados sobre origem racial ou étnica, convicção religiosa, opinião
                            política, entre outros, a depender da legislação aplicável.
                        </p>
                        <p>
                            Os responsáveis pelo tratamento de dados pessoais são os agentes de tratamento, denominados
                            como: “controlador”, “operador” e ainda podemos ter a figura do “suboperador”.
                        </p>
                        <p>
                            O “controlador” é a pessoa física ou jurídica a quem compete decidir sobre o tratamento de
                            dados pessoais em seu poder. Por outro lado, o “operador” é pessoa física ou jurídica que
                            realiza o tratamento de dados pessoais em nome e de acordo com as orientações do controlador
                            e, o “suboperador”, nessa mesma linha, é qualquer pessoa que auxilia o operador a realizar o
                            tratamento de dados pessoais em nome do controlador.
                        </p>
                    </li>
                    <br>

                    <li><span>TIPOS DE DADOS PESSOAIS COLETADOS</span> <br><br>
                        <p>Na decorrência da prestação de seus serviços, a BIOMETRIC poderá coletar os seguintes dados
                            pessoais:</p>
                        <ol type="a">
                            <li>Nome completo e dados de contato, como telefone e e-mail;</li>
                            <li>Fotografia;</li>
                            <li>Imagem da assinatura autógrafa/manuscrita;</li>
                            <li>Biometria da assinatura;</li>
                            <li>Vídeo do momento da assinatura;</li>
                            <li>Voz;</li>
                            <li>Foto ou vídeo de sua identificação (se solicitado pelo cliente);</li>
                            <li>Credenciais de conta, como senhas e outras informações de segurança para autenticação e
                                acesso;
                            </li>
                            <li>Informações para pagamento como número, validade e nome completo como está escrito no
                                cartão. Ainda podem ser solicitados dados para o preenchimento visando a nota fiscal da
                                compra como CPF/CNPJ.
                            </li>
                            <br>
                        </ol>
                    </li>

                    <li><span>ORIGEM DA COLETA DOS DADOS PESSOAIS</span> <br><br>
                        <p>
                            A BIOMETRIC, se for o caso, obterá dados pessoais do Usuário:
                        </p>
                        <ol type="a">
                            <li><strong>Por meio da interação com a BIOMETRIC e seus serviços:</strong> Quando o Usuário
                                usar a plataforma do FAD, utilizar nossos serviços, solicitar informações ou enviar
                                e-mail para o suporte.
                            </li>
                            <li><strong>Por meio de cookies:</strong> a BIOMETRIC poderá utilizar, em sua plataforma,
                                cookies para coletar informações do Usuário e melhorar sua experiência de navegação.
                            </li>
                        </ol>
                    </li>
                    <br>

                    <li><span>FINALIDADES PARA A COLETA  DOS DADOS PESSOAIS</span><br><br>
                        <p>Quando coletados, a BIOMETRIC utilizará os dados pessoais para as seguintes finalidades:</p>
                        <ol type="a">
                            <li>Realizar as atividades necessárias para fornecer ao Usuário serviços de multimídia de
                                assinatura autógrafa digital;
                            </li>
                            <li>Fornecer e melhorar os serviços, bem como para fins de compliance;</li>
                            <li>Cumprir com uma obrigação legal;</li>
                            <li>Quando for o caso, responder solicitações da Autoridade Nacional de Proteção de Dados
                                (ANPD) ou demais autoridades públicas e governamentais;
                            </li>
                            <li>Atender chamados e/ou pedidos de contatos, sempre que solicitado;</li>
                            <li>Processar pagamentos, mesmo que através de terceiros, ocasião na qual serão
                                compartilhados os dados estritamente necessários para a execução do contrato;
                            </li>
                            <li>Configurar e administrar a conta do Usuário;</li>
                            <li>Fornecer assistência técnica ao Usuário;</li>
                            <li>Fornecer ao Usuário marketing, publicidade, propaganda, incluindo promoções de nossos
                                serviços;
                            </li>
                            <li>Detectar, prevenir ou investigar possíveis incidentes de segurança ou fraudes.</li>
                        </ol>
                        <br>
                        <p>
                            Importante ressaltar que os dados sensíveis que forem coletados pela BIOMETRIC serão
                            eliminados imediatamente após a assinatura dos documentos.
                        </p>
                        <p>
                            Dessa forma, resta claro que, sempre nos limites impostos pela Lei, todo e qualquer
                            procedimento adotado que importe em coleta de dados pessoais terão apenas tratamentos
                            específicos vinculados essencialmente nas finalidades ora expostas.
                        </p>
                        <p>
                            Além disso, saiba que se tivermos a intenção de tratar os seus dados pessoais para qualquer
                            outra finalidade que não essas descritas acima, você receberá todas as informações
                            adicionais relevantes em relação ao eventual tratamento idealizado.
                        </p>
                        <p>
                            Ressaltamos que ao utilizar a nossa plataforma, o Usuário poderá acessar outras páginas na
                            Internet, as quais poderão coletar dados e informações gerais para finalidades distintas
                            daquelas aqui descritas. Dessa forma, é importante esclarecer que nós não nos
                            responsabilizamos pelo tratamento de dados realizado em tais páginas.
                        </p>
                        <p>
                            Por fim, esclarecemos que quando você não quiser que seus dados pessoais sejam utilizados
                            para envio de informações relacionadas a marketing, publicidade, propaganda e promoções,
                            você deverá nos informar através do e-mail: <a
                                href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                        </p>
                        <br>
                    </li>

                    <li><span>COMPARTILHAMENTO DOS DADOS PESSOAIS</span><br><br>
                        <p>A BIOMETRIC poderá compartilhar os seus dados em algumas situações com os seguintes parceiros
                            e/ou terceiros, conforme demonstramos a seguir:
                        </p>
                        <ol type="a">
                            <li>Empresas parceiras, tais como provedores de serviços terceirizados e outras empresas que
                                nos auxiliam no oferecimento de nossos serviços ou que possam tomar providências em
                                nosso nome, protegendo nossos direitos, usuários, sistemas e serviços;
                            </li>
                            <li>Terceiros para o qual a BIOMETRIC deva uma satisfação ou tenha autorização para
                                divulgação de informações por lei (Exemplo: órgãos governamentais, agências reguladoras,
                                poder judiciário e outras autoridades públicas);
                            </li>
                            <li>Terceiros a fim de participar da venda, fusão, aquisição, reestruturação, joint venture,
                                cessão, transferência de parte ou todo negócio da BIOMETRIC, hipótese na qual os dados
                                do Usuário serão considerados um ativo e transferidos em uma eventual negociação;
                            </li>
                            <li>Terceiros que necessitem dos dados para proteger os direitos da BIOMETRIC;</li>
                            <li>Qualquer pessoa física ou jurídica para o qual o Usuário solicite a portabilidade de
                                seus dados.
                            </li>
                            <br>
                        </ol>
                    </li>

                    <li><span>TRANSFERÊNCIA INTERNACIONAL DE DADOS PESSOAIS</span><br><br>
                        <p>
                            Conforme determina a atual legislação vigente, a transferência internacional de dados
                            pessoais será permitida, independentemente de consentimento do Usuário, nos seguintes casos:
                        </p>
                        <ol type="a">
                            <li>quando a transferência for necessária para a cooperação jurídica internacional entre
                                órgãos públicos de inteligência, de investigação e de persecução, de acordo com os
                                instrumentos de direito internacional;
                            </li>
                            <li>quando a transferência for necessária para a proteção da vida ou da incolumidade física
                                do titular ou de terceiro;
                            </li>
                            <li>quando a autoridade nacional autorizar a transferência;</li>
                            <li>quando a transferência resultar em compromisso assumido em acordo de cooperação
                                internacional;
                            </li>
                            <li>quando a transferência for necessária para a execução de política pública ou atribuição
                                legal do serviço público;
                            </li>
                            <li>quando o titular tiver fornecido o seu consentimento específico e em destaque para a
                                transferência, com informação prévia sobre o caráter internacional da operação,
                                distinguindo claramente essa de outras finalidades; ou
                            </li>
                            <li>nas demais hipóteses previstas na Lei Geral de Proteção de Dados brasileira.</li>
                            <br>
                        </ol>
                        <p>
                            A BIOMETRIC destaca o comprometimento em contratar apenas fornecedores que adotem
                            medidas de segurança e boas práticas compatíveis com o nível de proteção estabelecido
                            pela legislação brasileira, conforme regulamentado pela Autoridade Nacional de Proteção
                            de Dados (ANPD). Na ausência de regulamentação, asseguramos ao Usuário que utilizaremos
                            empresas que estejam em conformidade com as demais normas de proteção de dados no mundo.
                        </p>
                    </li>

                    <li><span>PRAZO DE TRATAMENTO DOS DADOS PESSOAIS</span><br><br>
                        <p>
                            A BIOMETRIC calcula o período de retenção dos dados pessoais de acordo com os seguintes
                            critérios:
                        </p>
                        <ol type="a">
                            <li>Período necessário para cumprir o propósito da coleta;</li>
                            <li>Quando o Usuário ou terceiro que concedeu acesso aos serviços da BIOMETRIC deixar de
                                utilizar estes serviços ou solicitar a revogação do consentimento;
                            </li>
                            <li>O tempo necessário para demonstrar o cumprimento dos deveres e obrigações da
                                BIOMETRIC;
                            </li>
                            <li>O período necessário previsto em Lei, regulamentações, decisões judiciais, etc;</li>
                            <li>Determinação da Autoridade Nacional de Proteção de Dados;</li>
                            <li>Cumprimento de obrigação legal ou regulatória pelo controlador;</li>
                            <li>Perfeita execução do contrato;</li>
                            <li>Necessidades atinentes a observância do ordenamento jurídico, bem como para eventuais
                                disputas judiciais;
                            </li>
                            <li>Estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados
                                pessoais;
                            </li>
                            <li>Transferência a terceiro, desde que respeitados os requisitos de tratamento de dados
                                dispostos em lei; ou
                            </li>
                            <li>Uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados
                                os dados.
                            </li>
                            <br>
                        </ol>
                    </li>

                    <li><span>DIREITOS DO TITULAR</span><br><br>
                        <p>Conforme Lei Geral de Proteção de Dados Brasileira, o Usuário terá os seguintes direitos
                            quanto ao tratamento de seus dados pessoais:</p>
                        <ol type="a">
                            <li><strong>Direito de Confirmação:</strong> o Usuário poderá confirmar se a BIOMETRIC
                                realiza o tratamento de algum dado pessoal seu;
                            </li>
                            <li><strong>Direito de Acesso:</strong> o Usuário poderá fazer uma solicitação por escrito
                                para obter detalhes de como suas informações estão sendo utilizadas, bem como de ter uma
                                cópia das referidas informações;
                            </li>
                            <li><strong>Direito a Correção:</strong> o Usuário poderá corrigir ou remover eventuais
                                dados seus que estejam incompletos, inexatos ou desatualizados;
                            </li>
                            <li><strong>Direito de Anonimização, bloqueio ou eliminação:</strong> o Usuário poderá
                                solicitar a anonimização, bloqueio ou eliminação de dados desnecessário, excessivos ou
                                tratados em desconformidade com as finalidades a qual deu consentimento, observando-se,
                                para tanto, demais normas do ordenamento jurídico;
                            </li>
                            <li><strong>Direito de Exclusão:</strong> o Usuário poderá solicitar a exclusão de alguns
                                dados, exceto aqueles em que a lei autorize a sua conservação;
                            </li>
                            <li><strong>Direito de Informação:</strong> O Usuário poderá solicitar informações das
                                entidades públicas e privadas com as quais a BIOMETRIC realizou o uso compartilhado de
                                seus dados, bem como das consequências caso opte por não consentir na coleta e
                                tratamento de seus dados pessoais;
                            </li>
                            <li><strong>Direito de Recusar Marketing:</strong> O Usuário, poderá, a qualquer momento,
                                solicitar o cancelamento de recebimento de propagandas e outros materiais pelo próprio
                                link disponibilizado no e-mail marketing enviado;
                            </li>
                            <li><strong>Direito de Portabilidade:</strong> O Usuário poderá solicitar que seus dados
                                pessoais sejam transferidos a si próprios ou terceiros, salvo aqueles que já tenham sido
                                anonimizados e excluídos pela BIOMETRIC;
                            </li>
                            <li><strong>Direito de Revogação do Consentimento:</strong> O Usuário poderá cancelar
                                qualquer consentimento concedido de maneira prévia à BIOMETRIC para utilizar seus dados
                                pessoais. O Usuário tem ciência que o cancelamento não afetará a utilização ou
                                compartilhamento dos dados realizados anteriormente ao pedido de revogação do
                                consentimento.
                            </li>
                            <br>
                        </ol>
                        <p>
                            Os direitos previstos neste capítulo não são absolutos, devendo o Usuário, sempre que quiser
                            exercê-los, contatar a BIOMETRIC através do canal: <a
                                href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                        </p>
                        <p>
                            Para que o atendimento seja realizado visando maior segurança para o Usuário e prevenindo
                            possíveis fraudes, é necessário que o titular, ao encaminhar a sua solicitação, envie para o
                            nosso e-mail:
                        </p>
                        <ol type="a">
                            <li>Nome completo;</li>
                            <li>Cópias simples ou cópia digital do documento de identificação oficial, para comprovação
                                de identidade, como, por exemplo: RG, CNH, passaporte;
                            </li>
                            <li>No caso de solicitação em nome de um menor de 18 (dezoito) anos, deverá ser apresentada
                                uma certidão de nascimento ou documento oficial que comprove a personalidade do pai/mãe
                                ou responsável.
                            </li>
                        </ol>
                        <br>
                        <p>
                            A BIOMETRIC ainda esclarece que:
                        </p>
                        <ol type="a">
                            <li>Quando for o caso de solicitação para exercer direito de titular d dados pessoais, em
                                nome de terceiro maior de 18 (dezoito) anos, o solicitante, deverá anexar uma procuração
                                comprovando seus poderes para agir;
                            </li>
                            <li>Em caso de retificação, anexe cópia da justificativa que comprove o erro nos dados que
                                deseja retificar;
                            </li>
                            <li>A confirmação de existência ou o acesso a dados pessoais serão providenciados, mediante
                                requisição do titular: em formato simplificado, imediatamente; ou por declaração clara e
                                completa, fornecida no prazo de até 15 (quinze) dias, e que indique origem dos dados,
                                critérios utilizados, finalidade do tratamento (observados os segredos comercial e
                                industrial);
                            </li>
                            <li>Caso o pedido feito pelo titular dos dados seja negado pela BIOMETRIC, o titular tem
                                direito de saber os motivos da rejeição e, ainda, de fazer uma reclamação à ANPD
                                (Autoridade Nacional de Proteção de Dados).
                            </li>
                            <br>
                        </ol>
                    </li>

                    <li><span>MEDIDAS DE SEGURANÇA ADOTADAS</span><br><br>
                        <p>A BIOMETRIC utiliza tecnologias e procedimentos adequados para proteger eventuais dados
                            pessoais coletados (incluindo proteção administrativas, técnicas e físicas) de acordo com o
                            nível de risco e o serviço fornecido, possuindo uma equipe legalmente responsável para lidar
                            com o gerenciamento seguro dos dados em consonância com as previsões legais, requisitos
                            regulatórios, mudanças de tecnologia, dentre outros fatores relevantes que possam
                            influenciar na forma de proteger os dados pessoais.</p>
                        <p>Nós empregamos todos os esforços razoáveis de mercado para garantir a segurança de seus
                            sistemas e dos dados coletados, utilizando provedores de Internet e servidores de bancos de
                            dados e armazenamento altamente qualificados e conceituados, além de certificados de
                            segurança (ISO 27001), criptografia nos centros de dados, e software de proteção contra
                            acesso não autorizado aos sistemas, bem como métodos padrões para criptografar e anonimizar
                            os dados coletados.</p>
                        <p>
                            A BIOMETRIC protege as informações geradas por apenas 30 (trinta) dias, após os quais são
                            automaticamente excluídas. A infraestrutura e os canais de comunicação estão sob protocolos
                            seguros e técnicas de criptografia.
                        </p>
                        <p>
                            No entanto, em razão da própria natureza da Internet, não é possível garantir que terceiros
                            mal-intencionados não logrem sucesso em acessar indevidamente as informações armazenadas,
                            razão pela qual, caso isso ocorra, a BIOMETRIC se responsabilizará nos limites previstos em
                            Lei.
                        </p>
                    </li>

                    <li><span>COOKIES</span><br><br>
                        <p>
                            A BIOMETRIC e seus fornecedores terceirizados poderão utilizar cookies para armazenar e
                            gerenciar as preferências do Usuário, oferecer publicidade direcionada, habilitar conteúdos
                            e coletar dados analíticos e de utilização, por exemplo. O uso de cookies e outras
                            tecnologias de rastreamento é um padrão em sites e plataforma, através do qual são coletadas
                            informações sobre as atividades do Usuário na plataforma, sites ou outros serviços.
                        </p>
                        <p>
                            Um cookie é um pequeno arquivo de texto, colocado em um computador ou outro dispositivo,
                            utilizado para identificar o Usuário, dispositivo utilizado e para coletar informações e
                            podem desempenhar as seguintes funções:
                        </p>
                        <ol type="a">
                            <li>Cookies Necessários: são essenciais para permitir que o Usuário navegue em uma
                                plataforma e utilize seus recursos.
                            </li>
                            <li>Cookies de Desempenho: eles coletam informações de como o Usuário utiliza a plataforma
                                da BIOMETRIC e servem para melhorar sua navegação e aprimorar sua experiência. As
                                informações coletadas incluem, por exemplo, navegadores de internet e sistemas
                                operacionais utilizados, o nome de domínio do site visitado anteriormente, o número de
                                visitas, a duração média da visita e as páginas visualizadas.
                            </li>
                            <li>Cookies Funcionais: eles permitem que a plataforma relembre escolhas que o Usuário fez
                                (tais como o seu nome de usuário ou ID, preferência de idioma ou a área ou região onde o
                                Usuário está) e forneça recursos aprimorados e mais pessoais.
                            </li>
                            <li>Cookies de Publicidade: eles rastreiam os hábitos de navegação do Usuário e são usados
                                para fornecer publicidade direcionada. Estes cookies também limitam o número de vezes
                                que você vê um anúncio e medem a eficácia das campanhas publicitárias. Eles lembram,
                                também, que o Usuário já visitou um site e esta informação é compartilhada com outras
                                organizações, como anunciantes.
                            </li>
                            <br>
                        </ol>
                        <p>
                            A BIOMETRIC utiliza os seguintes cookies:
                        </p>
                        <ol type="a">
                            <li>Entrada de Usuário;</li>
                            <li>Identificação;</li>
                            <li>Segurança do Usuário;</li>
                            <li>Sessão de balanceamento de carga;</li>
                            <li>Plug-in;</li>
                            <li>Propriedade;</li>
                            <li>Sessão;</li>
                            <li>Análise;</li>
                            <li>Publicidade.</li>
                            <br>
                        </ol>
                        <p>
                            A qualquer momento o Usuário poderá desabilitar os Cookies através das configurações de seu
                            navegador, instalando plug-ins disponíveis no mercado, ou ainda fazendo uso de outras
                            tecnologias que entenda serem necessárias.
                        </p>
                    </li>

                    <li><span>ENCARREGADO DE DADOS / DPO (“Data Protection Officer”)</span><br><br>
                        <p>A BIOMETRIC possui um encarregado de dados, também chamado de Data Protection Officer
                            (DPO).</p>
                        <p>
                            Dessa forma, conforme a LGPD determina, caso você tenha alguma questão específica sobre
                            proteção de dados que ainda não tenha sido esclarecida por nossa Política de Privacidade,
                            Termos de Uso do Website ou pelo Contrato específico que você tenha assinado conosco,
                            recomendamos que entre em contato com o DPO da BIOMETRIC através do seguinte e-mail:
                            <a href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                        </p>
                    </li>

                    <li><span>ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE</span><br><br>
                        <p>A BIOMETRIC busca constantes atualizações e aprimoramentos, assim a presente Política de
                            Privacidade poderá ser atualizada a qualquer tempo sempre visando uma melhor prestação e
                            proteção aos usuários.</p>
                        <p>
                            Por isso, é importante que o Usuário consulte o documento regularmente em
                            <a [routerLink]="['/termos-e-condicoes']">Assinatura</a>, para verificar se continua
                            concordando com
                            seus termos antes de seguir com a navegação ou com o preenchimento de algum recurso do
                            website.
                        </p>
                        <p>
                            Caso solicitado pelo Usuário, a presente Política de Privacidade poderá ser enviada por
                            e-mail.
                        </p>
                    </li>

                    <li><span>LEGISLAÇÃO E FORO</span><br><br>
                        <p>Essa Política será regida, interpretada e executada de acordo com as leis da República
                            Federativa do Brasil, independentemente dos conflitos dessas leis com leis de outros estados
                            ou países, sendo competente o Foro de São Paulo, para dirimir qualquer dúvida decorrente
                            deste instrumento. O Usuário consente, expressamente, com a competência desse juízo, e
                            renuncia, neste ato, à competência de qualquer outro foro, por mais privilegiado que seja ou
                            venha a ser.</p>
                    </li>
                </ol>
            </div>

        </div>
    </div>

</app-template>
